// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { TenantRole } from "./TenantRole";
import {
  TenantRoleFromJSON,
  TenantRoleFromJSONTyped,
  TenantRoleToJSON,
  TenantRoleToJSONTyped,
} from "./TenantRole";

/**
 *
 * @export
 * @interface UserRead
 */
export interface UserRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  givenName: string;
  /**
   *
   */
  familyName: string;
  /**
   *
   */
  email: string;
  /**
   *
   */
  lastLogin?: Date | null;
  /**
   *
   */
  identityProviderId: string;
  /**
   *
   */
  role?: TenantRole | null;
  /**
   *
   */
  active?: boolean;
}

/**
 * Check if a given object implements the UserRead interface.
 */
export function instanceOfUserRead(value: object): value is UserRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (
    (!("givenName" in (value as Record<string, any>)) &&
      !("given_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["givenName"] === undefined &&
      (value as Record<string, any>)["given_name"] === undefined)
  )
    return false;
  if (
    (!("familyName" in (value as Record<string, any>)) &&
      !("family_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["familyName"] === undefined &&
      (value as Record<string, any>)["family_name"] === undefined)
  )
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (
    (!("identityProviderId" in (value as Record<string, any>)) &&
      !("identity_provider_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["identityProviderId"] === undefined &&
      (value as Record<string, any>)["identity_provider_id"] === undefined)
  )
    return false;
  return true;
}

export function UserReadFromJSON(json: any): UserRead {
  return UserReadFromJSONTyped(json, false);
}

export function UserReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    givenName: json["given_name"],
    familyName: json["family_name"],
    email: json["email"],
    lastLogin:
      json["last_login"] === undefined
        ? undefined
        : json["last_login"] === null
        ? null
        : parseDateTime(json["last_login"]),
    identityProviderId: json["identity_provider_id"],
    role:
      json["role"] === undefined
        ? undefined
        : json["role"] === null
        ? null
        : TenantRoleFromJSON(json["role"]),
    active: json["active"] == null ? undefined : json["active"],
  };
}

export function UserReadToJSON(json: any): UserRead {
  return UserReadToJSONTyped(json, false);
}

export function UserReadToJSONTyped(
  value?: UserRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    given_name: value["givenName"],
    family_name: value["familyName"],
    email: value["email"],
    last_login:
      value["lastLogin"] == null ? value["lastLogin"] : serializeDateTime(value["lastLogin"]),
    identity_provider_id: value["identityProviderId"],
    role: TenantRoleToJSON(value["role"]),
    active: value["active"],
  };
}
